import { ReactElement } from 'react'
import { FeedbackBox } from '../feedback-box'

interface Props {
  errors: string[]
}

export function ErrorMessages(props: Props): ReactElement | null {
  if (props.errors.length === 0) {
    return null
  }

  return (
    <div role="status" className="grid gap-2">
      {props.errors.map((e) => (
        <FeedbackBox key={e} variant="error-dark" text={e} />
      ))}
    </div>
  )
}
